import import_latest_version_module from '@/component/admin-layout/import_latest_version_module';

export default {
    path: '',
    component: () => import_latest_version_module(),
    children: [
        {
            path: '/admin/mocha/home',
            name: 'admin-mocha-home',
            component: () => import(/* webpackChunkName: "page-admin-mocha-home" */ `./index.vue`),
            meta: {
                data_for_admin_layout: {
                    data_for_history_tag: {
                        entity: {
                            name: "主页"
                        }
                    },
                    data_for_breadcrumb: {
                        entity_list: [
                            {
                                name: "mocha"
                            },
                            {
                                name: "主页"
                            }
                        ]
                    }
                }
            },

        },
    ],
};
